import styled from 'styled-components';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import { tablet768, desktop1024 } from '@nubank/nuds-web/styles/breakpoints';

import { paddingBuilder, themeSpace } from 'styles/themeUtils';

const SectionTitle = styled(Typography)`
  margin-bottom: ${themeSpace(1.5)};

  ${tablet768`
    margin-bottom: 0px;
    ${paddingBuilder.right(5)}

    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 50%;
  `}

  ${desktop1024`
    ${paddingBuilder.right(12.5)}
  `}

  ${desktop1024`
    ${paddingBuilder.right(10.5)}
  `}
`;

SectionTitle.displayName = 'SectionTitle';

export default SectionTitle;
